module.exports = __webpack_public_path__ + "static/assets/6055c99d4dcb9541409433b95d3c6256.png";